import { getCurrentLanguage } from "utils/src/getCurrentLanguage";
import { apiClient } from "../../../../apps/crossword-maker/src/shared/apiClient";
import {
	ICrosswordBookWordEntity,
	ICreateCrosswordBookWordDto,
} from "./CrosswordBook.api.types";

export type TCreateWord = (
	data: ICreateCrosswordBookWordDto,
) => Promise<ICrosswordBookWordEntity>;

export const createWord: TCreateWord = async (data) => {
	const language = getCurrentLanguage();
	const response = await apiClient().post<ICrosswordBookWordEntity>(
		`/rest/${language}/crossword-book/word`,
		data
	);
	return response.data;
};
